import { css } from '@/styled-system/css';

export const WaitlistSuccessPopup = css({
  width: '100%',
  padding: '16px',
  md: {
    maxWidth: '420px',
  },
});

export const SimilarListingsContainer = css({
  width: '100%',
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  gap: '16px',
});
